module.exports = __webpack_public_path__ + "img/sub_page_communication10.e6fcf0c7.png";